<template>
	<div>
		<div id="div-with-loading" class="dashboard-page">
			<div class="vx-row mt-5">
				<!-- All Promos Snapshot -->
				<div class="vx-col w-1/2">
					<h4 class="heading">All Promos Snapshot</h4>

					<div class="expiring-promo-count flex">
						<ul class="ul-tabs vs-tabs--ul ul-tabs-left flex promos-tabs-ul">
							<li class="vs-tabs--li promos-tabs" id="expiring-in-a-week-tab">
								<button type="button" class="vs-tabs--btn px-5 text-center expiring-promo-count--action-btn" @click="filterPromos('expiring-in-a-week')">
									<small class="mb-2 w-10 h-10 inline-flex items-center justify-center rounded-lg text-dark expiring-in-week">{{ expiringInAWeekCount }}</small>
									<div class="text-center"><strong> Expiring in a week </strong></div>
								</button>
							</li>

							<li v-if="!$acl.check('isSuperAdmin') && !$acl.check('isChannelAdmin')" class="vs-tabs--li promos-tabs" id="expiring-in-two-weeks-tab">
								<button type="button" class="vs-tabs--btn px-5 text-center expiring-promo-count--action-btn d-none" @click="filterPromos('expiring-in-two-weeks')">
									<small class="mb-2 w-10 h-10 inline-flex items-center justify-center rounded-lg text-dark expiring-in-two-weeks">{{ expiringInTwoWeeksCount }}</small>
									<div class="text-center"><strong> Expiring in two weeks </strong></div>
								</button>
							</li>

							<li class="vs-tabs--li promos-tabs" id="expired-tab">
								<button class="vs-tabs--btn px-5 text-center expiring-promo-count--action-btn" @click="filterPromos('expired')">
									<small class="mb-2 w-10 h-10 inline-flex items-center justify-center rounded-lg text-dark expired">{{ expiredCount }}</small>
									<div class="text-center"><strong> Expired </strong></div>
								</button>
							</li>

							<li class="vs-tabs--li promos-tabs" id="erroneous-tab">
								<button class="vs-tabs--btn px-5 text-center expiring-promo-count--action-btn" @click="filterPromos('erroneous')">
									<small class="mb-2 w-10 h-10 inline-flex items-center justify-center rounded-lg text-dark erroneous">{{ erroneousCount }}</small>
									<div class="text-center"><strong> Erroneous </strong></div>
								</button>
							</li>

							<li v-if="$acl.check('isSuperAdmin') || $acl.check('isChannelAdmin')" class="vs-tabs--li promos-tabs" id="new-requests-tab">
								<button class="vs-tabs--btn px-5 text-center expiring-promo-count--action-btn" @click=" filterPromos('new-requests')">
									<small class="mb-2 w-10 h-10 inline-flex items-center justify-center rounded-lg text-dark new-req">{{ newRequestsCount }}</small>
									<div class="text-center"><strong> New Requests </strong></div>
								</button>
							</li>

							<li v-if="$acl.check('isSuperAdmin') || $acl.check('isChannelAdmin')" class="vs-tabs--li promos-tabs" id="edit-requests-tab">
								<button class="vs-tabs--btn px-5 text-center expiring-promo-count--action-btn" @click=" filterPromos('edit-requests')">
									<small class="mb-2 w-10 h-10 inline-flex items-center justify-center rounded-lg text-dark edit-req">{{ editRequestsCount }}</small>
									<div class="text-center"><strong> Edit Requests </strong></div>
								</button>
							</li>
						</ul>

						<span id="line-vs-tabs-promos" class="line-vs-tabs line-vs-tabs-promos"></span>
					</div>

					<hr class="ml-6">

					<div class="promos-grids">
						<vs-collapse class="promos-collapse">
							<!-- CNIC Promos-->
							<vs-collapse-item open class="mt-4" v-if="!disableCNICFlag">
								<div slot="header" class="promo-type-header">CNIC Promos</div>
								<CNICPromoDashboardComponent :filteredData="filteredCNICData" :activeFilterStatus="activeFilterStatus"></CNICPromoDashboardComponent>
							</vs-collapse-item>
							<!-- CNIC Promos -->

							<!-- Tucows Promos-->
							<!-- <vs-collapse-item open class="mt-4">
								<div slot="header" class="promo-type-header">Tucows Promos</div>
								<TucowsPromoDashboardComponent :filteredData="filteredTucowsData" :activeFilterStatus="activeFilterStatus"></TucowsPromoDashboardComponent>
							</vs-collapse-item> -->
							<!-- Tucows Promos -->

							<!-- Internal Promos -->
							<vs-collapse-item open class="mt-4">
								<div slot="header" class="promo-type-header">Internal Promos</div>
								<InternalPromoDashboardComponent :filteredData="filteredInternalData" :activeFilterStatus="activeFilterStatus"></InternalPromoDashboardComponent>
							</vs-collapse-item>
							<!-- Internal Promos -->

							<!-- MIS -->
							<vs-collapse-item open class="mt-4">
								<div slot="header" class="promo-type-header">MIS</div>
								<MISDashboardComponent :filteredData="filteredMISData" :activeFilterStatus="activeFilterStatus"></MISDashboardComponent>
							</vs-collapse-item>
							<!-- MIS -->
						</vs-collapse>
					</div>
				</div>

				<!-- Notifications Card -->
				<div class="vx-col w-1/2">
					<h4 class="notifications-heading">Notifications</h4>

					<div class="ml-auto justify-center flex items-center">
						<vx-card class="notifications-card mb-base body-p0">
							<div class="con-ul-tabs">
								<ul class="ul-tabs vs-tabs--ul ul-tabs-left flex">
									<li class="vs-tabs--li notifications-tabs" id="promos-tab" >
										<button type="button" class="vs-tabs--btn" @click="filterNotifications('promos')">
											<span>Promos</span> <transition name="slide-fade" mode="out-in"> <vs-chip v-if="notifications.filter(x => x.data && x.data.feature == 'promos' && !x.read_at).length" color="primary" class="notification-tab-badge">{{ notifications.filter(x => x.data && x.data.feature == 'promos' && !x.read_at).length }}</vs-chip> </transition>
										</button>
									</li>

									<li class="vs-tabs--li notifications-tabs" id="agreements-tab">
										<button type="button" class="vs-tabs--btn" @click="filterNotifications('agreements')">
											<span>Agreements</span> <vs-chip v-if="notifications.filter(x => x.data && x.data.feature == 'agreements' && !x.read_at).length" color="primary" class="notification-tab-badge">{{ notifications.filter(x => x.data && x.data.feature == 'agreements' && !x.read_at).length }}</vs-chip>
										</button>
									</li>

									<li class="vs-tabs--li notifications-tabs" id="rebates-tab">
										<button type="button" class="vs-tabs--btn" @click="filterNotifications('rebates')">
											<span>Rebates</span> <vs-chip v-if="notifications.filter(x => x.data && x.data.feature == 'rebates' && !x.read_at).length" color="primary" class="notification-tab-badge">{{ notifications.filter(x => x.data && x.data.feature == 'rebates' && !x.read_at).length }}</vs-chip>
										</button>
									</li>

									<li class="vs-tabs--li notifications-tabs" id="mdfs-tab">
										<button type="button" class="vs-tabs--btn" @click="filterNotifications('mdfs')">
											<span>MDFs</span> <vs-chip v-if="notifications.filter(x => x.data && x.data.feature == 'mdfs' && !x.read_at).length" color="primary" class="notification-tab-badge">{{ notifications.filter(x => x.data && x.data.feature == 'mdfs' && !x.read_at).length }}</vs-chip>
										</button>
									</li>
								</ul>

								<span id="line-vs-tabs-notifications" class="line-vs-tabs"></span>
							</div>

							<div class="con-slot-tabs notifications-list-container">
								<div class="con-tab vs-tabs--content">
									<div class="tab-text">
										<div v-if="filteredNotifications.length">
											<TransitionGroup name="list" tag="ul">
												<li v-for="(notification, index) in filteredNotifications" :key="`notification-${index}`">
													<hr>

													<div class="vx-row notification--row mb-2">
														<div class="vx-col new-notification-col pr-0">
															<div v-if="!notification.read_at" class="notification--avatar__new-dot ml-auto"></div>
														</div>

														<div class="vx-col avatar-col pl-0">
															<div class="notification--avatar">
																<vs-avatar :text="notification.data.user"></vs-avatar>
															</div>
														</div>

														<div class="vx-col message-col pr-0">
															<div class="notification--message">
																<span class="notification--message__user">{{ notification.data.user }}</span> {{ notification.data.message + ': ' +  notification.data.resources.join(', ')}}
															</div>
															<div v-if="notification.data.comment" class="notification--comment">
																{{ notification.data.comment }}
															</div>
															<div v-else class="notification--view">
																Click on this notification to view the promo.
															</div>
														</div>

														<div class="vx-col meta-col flex my-auto pr-0">
															<div class="notification--time">
																{{ formatTime(notification.data.time) }}
															</div>
															<div>
																<vs-button color="dark" type="flat" icon-pack="feather" icon="icon-external-link" @click="markAsRead(notification)"></vs-button>
															</div>
														</div>
													</div>
												</li>
											</TransitionGroup>
										</div>

										<!-- No Notifications -->
										<div v-else>
											<div class="text-center my-3 notification--message">
												<hr>

												You're all caught up!

												<hr class="my-3">
											</div>
										</div>
										<!--  -->
									</div>
								</div>
							</div>
						</vx-card>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import CNICPromoDashboardComponent from "@/components/ag-grid-tables/dashboard/CNICPromoDashboardComponent.vue";
// import TucowsPromoDashboardComponent from "@/components/ag-grid-tables/dashboard/TucowsPromoDashboardComponent.vue";
import InternalPromoDashboardComponent from "@/components/ag-grid-tables/dashboard/InternalPromoDashboardComponent.vue";
import MISDashboardComponent from "@/components/ag-grid-tables/dashboard/MISDashboardComponent.vue";
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: process.env.VUE_APP_MIX_PUSHER_APP_KEY,
	cluster: process.env.VUE_APP_MIX_PUSHER_APP_CLUSTER,
	wsHost: process.env.VUE_APP_API,
	authEndpoint: process.env.VUE_APP_API+'/broadcasting/auth',
	auth: {
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('accessToken')
		}
	},
	forceTLS: true,
	encrypted: true
});

export default {
	name: 'Dashboard',
	components: {
		CNICPromoDashboardComponent,
		// TucowsPromoDashboardComponent,
		InternalPromoDashboardComponent,
		MISDashboardComponent
	},
	computed: {
		user_id() {
			return JSON.parse(localStorage.getItem("userDetails")).id;
		},
		disableCNICFlag() {
			return this.$store.getters.getDisableCNICFlag;
		}
	},
	watch: {
		disableCNICFlag(val) {
			return this.$store.getters.getDisableCNICFlag;
		}
	},
	created() {
		this.queueNotifications();

		window.Echo.private('App.User.' + this.user_id).notification(response => {
			// NOTE: Format notification object
			this.notifications.push(response);
			// NOTE: Sort notifications by latest first
			this.notifications.sort((a, b) => { return Boolean(a.read_at) - Boolean(b.read_at) || a.created_at - b.created_at });
		})
	},
	data() {
		return {
			// TODO: Get from backend API
			expiringInAWeekCount: 0,
			expiringInTwoWeeksCount: 0,
			expiredCount: 0,
			erroneousCount: 0,
			newRequestsCount: 0,
			editRequestsCount: 0,
			filteredCNICData: null,
			filteredInternalData: null,
			filteredMISData: null,
			notifications: [],
			filteredNotifications: [],
			activeFilterStatus: 'expiring-in-a-week'
		}
	},
	mounted() {
		this.fetchCountData();
		this.filterPromos(this.activeFilterStatus);
	},
	destroyed() {
	},
	methods: {
		fetchCountData() {
			this.$axiosSecure.get(`/dashboard/counts`).then(response => {
				this.expiringInAWeekCount = response.data.expiring_in_week;
				this.expiringInTwoWeeksCount = response.data.expiring_in_two_weeks;
				this.expiredCount = response.data.expired;
				this.erroneousCount = response.data.erroneous;
				this.newRequestsCount = response.data.new_requests;
				this.editRequestsCount =response.data.edit_requets;
			})
			.catch(error => {
				this.$vs.notify({
					color: "danger",
					title: "Something went wrong",
					text: "Please contact the server admin",
				});
			})
		},
		filterPromos(filterStatus) {
			this.activeFilterStatus = filterStatus;
			let featureTab = document.getElementById(`${filterStatus}-tab`);
			
			document.querySelectorAll('.promos-tabs.vs-tabs--li.activeChild').forEach(x => {
				x.classList.remove('activeChild');
			})
			
			featureTab.classList.add('activeChild');

			// NOTE: Get a list of all tabs to iterate through to calculate left spacing
			let liTabs = document.getElementsByClassName('promos-tabs');

			let calcLeftSpacing = 0;
			for(var i = 0; i < liTabs.length; i++) {
				if(liTabs[i].classList.contains('activeChild')) {
					break;
				} else {
					calcLeftSpacing += liTabs[i].offsetWidth;
				}
			}

			let lineTab = document.getElementById('line-vs-tabs-promos');
			// Left spacing from the remaining tabs & width of the highlight line
			lineTab.style.left = (calcLeftSpacing+((featureTab.offsetWidth/2)+10))+'px';
			// lineTab.style.width = featureTab.children[0].children[0].offsetWidth+2+'px';
			
			// ----------------------------------------------------------------------

			// Get filtered promos
			this.$axiosSecure.get(`/dashboard/${filterStatus}`).then(response => {
				this.filteredCNICData = response.data.cnic_data ? response.data.cnic_data : [];
				// this.filteredTucowsData = response.data.tucows_promo_data ? response.data.tucows_promo_data : [];
				this.filteredInternalData = response.data.local_promo_data ? response.data.local_promo_data : [];
				this.filteredMISData = response.data.mis_data ? response.data.mis_data : [];
			})
			.catch(error => {
				this.$vs.notify({
					color: "danger",
					title: "Something went wrong",
					text: "Please contact the server admin",
				});
			})
		},
		queueNotifications() {
			// NOTE: API to queue notifications from the backend
			this.$axiosSecure.get(`/notifications/all/${this.user_id}`)
			.then(response => {
				this.notifications = this.formatNotificationToStandardFormat(response.data);
				this.notifications.sort((a, b) => { return Boolean(a.read_at) - Boolean(b.read_at) || a.created_at - b.created_at });
				this.filterNotifications('promos');
			})
			.catch(error => {
				this.$vs.notify({
					color: "danger",
					title: "Something went wrong",
					text: "Please contact the server admin",
				});
			})
		},
		filterNotifications(feature) {
			let featureTab = document.getElementById(`${feature}-tab`);
			
			document.querySelectorAll('.notifications-tabs.vs-tabs--li.activeChild').forEach(x => {
				x.classList.remove('activeChild');
			})
			
			featureTab.classList.add('activeChild');

			// NOTE: Get a list of all tabs to iterate through to calculate left spacing
			let liTabs = document.getElementsByClassName('notifications-tabs');

			let calcLeftSpacing = 0;
			for(var i = 0; i < liTabs.length; i++) {
				if(liTabs[i].classList.contains('activeChild')) {
					break;
				} else {
					calcLeftSpacing += liTabs[i].offsetWidth;
				}
			}

			let lineTab = document.getElementById('line-vs-tabs-notifications');
			// Left spacing from the remaining tabs & width of the highlight line
			lineTab.style.left = (calcLeftSpacing+10)+'px';
			lineTab.style.width = featureTab.children[0].children[0].offsetWidth+'px';
			this.filteredNotifications = this.notifications.filter(x => x.data && x.data.feature == feature);
			this.filteredNotifications.sort((a, b) => { return Boolean(a.read_at) - Boolean(b.read_at) || a.created_at - b.created_at });
			// TODO: Trim the length of notifications and update the count later
			// this.filteredNotifications = this.filteredNotifications.slice(10)
		},
		formatTime(time) {
			let timeDiff = this.$moment(new Date()).diff(time, 'days');
			if(timeDiff == 0) {
				timeDiff = this.$moment(new Date()).diff(time, 'hours');
				if(timeDiff == 1) {
					return timeDiff + 'hr ago'
				} else {
					return timeDiff + 'hrs ago'
				}
			} else {
				if(timeDiff == 1) {
					return timeDiff + 'day ago';
				} else {
					return timeDiff + 'days ago';
				}
			}
		},
		markAsRead(notification) {
			if(notification.read_at) {
				this.$router.push(notification.data.url);
			} else {
				// NOTE: Mark notification as read
				this.$axiosSecure.post(`/notifications/read/${this.user_id}/${notification.id}`)
				.then(response => {
					this.queueNotifications();
					// NOTE: Navigate to respective list as per manner of notification on click of the notification
					this.$router.push(notification.data.url);
				})
				.catch(error => {
					this.$vs.notify({
						color: "danger",
						title: "Something went wrong",
						text: "Please contact the server admin",
					});
				})
			}
		},
		formatNotificationToStandardFormat(sourceData) {
			return sourceData.map(x => {
				return {
					id: x.id,
					created_at: x.created_at,
					read_at: x.read_at,
					data: x.data.data
				}
			})
		}
	},
}
</script>